import * as React from "react";
import { Concept } from "../../../../../server/models/concept";
import { useParams, useNavigate } from "react-router-dom";
import { ConceptPreviewPage } from "../../../components/pages/concept/preview";
import { get, makeError } from "../../../lib/request";
import { PreviewConceptResponse } from "../../../../../server/types/request/concept";
import { endpoint, replaceEndpointUrl } from "../../../../../server/router/endpoint";
import { MessageInfo } from "../../../types/info";
import { ConfirmBox } from "../../../components/parts/confirm-box";
import { clientEndpoint } from "../../../routes/endpoint";

export const ConceptPreviewContainer = () => {
	const [concepts, setConcepts] = React.useState<Concept[]>([]);
	const [info, setInfo] = React.useState<MessageInfo>({ isSuccess: true, message: "" });
	const { jobId, activityId } = useParams<{
		jobId: string;
		activityId: string;
	}>();
	const navigate = useNavigate();
	React.useEffect(() => {
		get<PreviewConceptResponse>(`${endpoint.conceptPreview}/${jobId}`)
			.then((response) => {
				setConcepts(response.data.concepts);
			})
			.catch((error) => {
				setInfo(makeError(error));
			});
	}, [jobId]);
	const onEditPage = React.useCallback(() => {
		navigate(replaceEndpointUrl(clientEndpoint.concept, { activityId, jobId }));
	}, [activityId, jobId, navigate]);
	return (
		<>
			<ConfirmBox info={info} titleLabel={"取得処理"} />
			<ConceptPreviewPage concepts={concepts} onEditPage={onEditPage} />
		</>
	);
};
